import { ApiGetWxConfig } from "@/api/wx-config";
import { captureMessage } from "./sentry";

/**
 * 微信配置wx.config
 * @param props 配置参数
 * @param props.url 需要签名的url，默认是当前页面url
 * @param props.wxConfig 微信配置的参数选项
 * @param props.configComplete 配置完成回调
 * @param props.onReady wx.ready回调
 */
export const wxConfig = (props: {
  url?: string;
  wxConfig?: Record<string, any>;
  configComplete?: (config: any) => void;
  onReady?: () => void;
}) => {
  ApiGetWxConfig(props.url || window.location.href.split("#")[0])
    .then(res => {
      if (res) {
        const { code, data } = res;
        if (code === 200 && data) {
          const config = data.weixinJsApiSignature;
          window.wx?.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: config.appId, // 必填，公众号的唯一标识
            timestamp: config.timestamp, // 必填，生成签名的时间戳
            nonceStr: config.nonceStr, // 必填，生成签名的随机串
            signature: config.signature, // 必填，签名
            jsApiList: [
              // 必填，需要使用的JS接口列表
              "updateAppMessageShareData", // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
              "updateTimelineShareData", // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
              "showMenuItems", // 批量显示功能按钮接口
              "chooseWXPay", // 发起一个微信支付请求
              "checkJsApi",
              "previewImage",
              "chooseImage",
              "getLocalImgData",
              "hideAllNonBaseMenuItem",
            ],
            ...props.wxConfig,
          });
          props.configComplete?.(config);
        } else {
          captureMessage(`微信签名失败 (api/member/signature) (${JSON.stringify(res)})`, "warning");
        }
        window.wx?.ready(() => {
          props.onReady?.();
        });
        window.wx.error((res2: any) => {
          console.error("微信签名失败", res2);
          captureMessage(`微信签名失败 (window.wx.error) (${JSON.stringify(res2)})`, "warning");
        });
      }
    })
    .catch(err => {
      captureMessage(
        `微信签名失败 (api/member/signature) (${err}、${typeof window.wx === "object" ? Object.keys(window.wx) : window.wx})`,
        "warning",
      );
    });
};
